module.exports = __webpack_public_path__ + "img/reason_05@2x.9c515ae9.png";